import { Link } from 'react-router-dom';
import ProjectIcon from '../../ProjectIcon/ProjectIcon';
import Icon from '../../ui/Icon/Icon';
import type { Project } from '../../../data/projects';
import { useProjectCopy } from '../../../hooks/useProjectCopy';
import { useProjectKeyFact } from '../../../hooks/useProjectKeyFact';
import { useLanguage } from '../../../i18n/useLanguage';
import styles from './ProjectRows.module.css';

export default function ProjectRows({ projects }: { projects: Project[] }) {
    const { localizedPath } = useLanguage();
    const projectCopy = useProjectCopy();
    const keyFact = useProjectKeyFact();

    return (
        <ul className={styles.rows}>
            {projects.map((project) => (
                <li key={project.slug}>
                    <Link to={localizedPath(`/work/${project.slug}`)} className={styles.row}>
                        <ProjectIcon project={project} size="medium" />
                        <div className={styles.text}>
                            <h3 className={styles.name}>{project.name}</h3>
                            <p className={styles.category}>{projectCopy(project.slug).category}</p>
                        </div>
                        <span className={styles.fact}>{keyFact(project)}</span>
                        <span className={styles.arrow} aria-hidden="true">
                            <Icon name="arrowRight" />
                        </span>
                    </Link>
                </li>
            ))}
        </ul>
    );
}
